import React from 'react'

const Option = function (props) {
  const { value, text, type } = props

  return (
    <option className={type} value={value}>
      {text}
    </option>
  )
}

export default Option
